// removed by extract-text-webpack-plugin
module.exports = {"doubleBorder":"MemberModerationContainer__doubleBorder___2-tMv"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/memberModeration/containers/MemberModerationContainer.scss
// module id = 1719
// module chunks = 0